export const LABEL_WORKBENCH = 'Workbench';
export const LABEL_DISCOVERER = 'Discoverer';
